import { FC } from 'react'
import { PerAvatar } from '../../components/custom_components/Avatar'

type SmartAvatarProps = {
  employeeId: number
  firstName?: string
  lastName?: string
  size?: 'large' | 'small' | 'default' | 'xlarge' | 'xxxlarge'
  square?: boolean
  unknown?: boolean
}

export const SmartAvatar: FC<SmartAvatarProps> = ({ employeeId, firstName, lastName, size, square, unknown }) => {
  return (
    <PerAvatar src={`/rest/avatar/${employeeId}`} firstName={firstName} lastName={lastName} size={size} square={square} unknown={unknown} />
  )
}
